import React, { useState } from 'react'
import { BeamDesignerWorkspace } from '@structura/beam-analysis'
import { ShareEditor } from '@structura/sharing'
import { sharingClient } from '../../sharing.config'

/**
 * Wood beam designer page (/beam/wood).
 *
 * Independent page shell composing the shared analysis workspace. Covers both
 * glulam and solid timber via an in-page toggle inside the workspace. Timber-specific
 * panels and integrations belong on this page as the apps diverge.
 */
const WoodBeam: React.FC = () => {
  const [sharing, setSharing] = useState<{ id: string; name: string } | null>(null)
  return (
    <>
      <BeamDesignerWorkspace material="timber" onShareDesign={setSharing} />
      {sharing && (
        <ShareEditor
          client={sharingClient}
          resourceType="beam-design"
          resourceId={sharing.id}
          title={sharing.name}
          onClose={() => setSharing(null)}
        />
      )}
    </>
  )
}

export default WoodBeam
